/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type api_updateAlumniSurveyAnswerDecisionRequest = {
    alumni_survey_answer_id: number;
    decision?: api_updateAlumniSurveyAnswerDecisionRequest.decision;
    item_decisions?: Record<string, Array<string>>;
};
export namespace api_updateAlumniSurveyAnswerDecisionRequest {
    export enum decision {
        ACCEPTED = 'accepted',
        REJECTED = 'rejected',
    }
}

